import BlogCardPreview from "./components/BlogCardPreview";
import "./Blog.css";
import { Helmet } from "react-helmet";

function Blogs(props) {
  return (
    <>
      <Helmet>
        <title>Nepeto - Blog</title>
        <meta
          name="description"
          content="Discover valuable insights on Amazon FBA and product sourcing with Nepeto's blog. Learn expert tips and strategies for e-commerce success. Start your journey to growth and profit today!"
        />
        <meta
          name="keywords"
          content="amazon fba, product sourcing, e-commerce, success, amazon fba products, fba products, fba sourcing"
        />
      </Helmet>
      <h1
        style={{
          fontSize: props.isMobile ? "3vh" : "2vw",
          fontWeight: "200",
          textAlign: "center",
          color: "#8c3e7c",
          marginBottom: props.isMobile && "2vh",
        }}
      >
        Nepeto Blog
      </h1>

      <div className="columns is-multiline">
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Getting Started with Amazon FBA for Beginners"}
            img={"/blogs/blog7/preview.png"}
            writer={"Jon Hlyo"}
            minRead={13}
            href={"/blog/getting-started-with-amazon-fba-for-beginners"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Why Sell on Amazon?"}
            img={"/blogs/template/image.png"}
            writer={"Ido Sarusi"}
            minRead={7}
            href={"/blog/why-sell-on-amazon"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={
              "Best Practices for Customer Relations and Feedback Management"
            }
            img={"/blogs/blog5/preview.png"}
            writer={"Jon Hlyo"}
            minRead={3}
            href={
              "/blog/best-practices-for-customer-relations-and-feedback-management"
            }
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"How to Skyrocket your Sales as an Amazon FBA Seller"}
            img={"/blogs/blog8/preview.png"}
            writer={"Jon Hlyo"}
            minRead={12}
            href={"/blog/how-to-skyrocket-your-sales-as-an-amazon-fba-seller"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"The Best Products for Amazon Arbitrage"}
            img={"/blogs/blog9/preview.png"}
            writer={"Jon Hlyo"}
            minRead={11}
            href={"/blog/the-best-products-for-amazon-arbitrage"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"How to Find Amazon Arbitrage Products"}
            img={"/blogs/blog10/preview.png"}
            writer={"Jon Hlyo"}
            minRead={13}
            href={"/blog/how-to-find-amazon-arbitrage-products"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Guide to Elevate Your Profit Game"}
            img={"/blogs/blog11/preview.png"}
            writer={"Jon Hlyo"}
            minRead={17}
            href={"/blog/amazon-arbitrage-boost-profit"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"How to Find Amazon Arbitrage Products in 2023 - Part 2"}
            img={"/blogs/blog12/preview.png"}
            writer={"Jon Hlyo"}
            minRead={19}
            href={"/blog/how-to-find-amazon-arbitrage-products-in-2023-part-2"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Unravelling the Mystery: Exploring the World of FBA Prep"}
            img={"/blogs/blog13/preview.png"}
            writer={"Jon Hlyo"}
            minRead={11}
            href={"/blog/exploring-the-world-of-fba-prep"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Top Nepeto Alternatives for 2023"}
            img={"/blogs/blog14/preview.png"}
            writer={"Jon Hlyo"}
            minRead={9}
            href={"/blog/top-nepeto-alternatives-for-2023"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"What is Nepeto"}
            img={"/blogs/blog15/preview.png"}
            writer={"Jon Hlyo"}
            minRead={10}
            href={"/blog/what-is-nepeto"}
          />
        </div>
        <a
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
          href="https://jordiob.com/amazon-tools/nepeto/"
        >
          <BlogCardPreview
            title={"Jordi Ordonez's Review"}
            img={"/assets/jordi.jpeg"}
            writer={"Jordi Ordonez"}
            minRead={7}
          />
        </a>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"What Are OOS Products"}
            img={"/blogs/blog17/preview.png"}
            writer={"Jon Hlyo"}
            minRead={9}
            href={"/blog/what-are-oos-products"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Success In Q4 With Nepeto"}
            img={"/blogs/blog18/preview.png"}
            writer={"Jon Hlyo"}
            minRead={16}
            href={"/blog/success-in-q4-with-nepeto"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Product Sourcing Software: What Actually Finds Profitable Amazon Deals in 2026"}
            img={"/blogs/product-sourcing-software/image.png"}
            writer={"Ido Sarusi"}
            minRead={7}
            href={"/blog/product-sourcing-software"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Amazon Product Sourcing in 2026: How Top Sellers Actually Find Profitable Inventory"}
            img={"/blogs/amazon-product-sourcing/aisle.png"}
            writer={"Ido Sarusi"}
            minRead={8}
            href={"/blog/amazon-product-sourcing"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Best Amazon Sourcing Software in 2026: What Pro Sellers Actually Use"}
            img={"/blogs/best-amazon-sourcing-software/image.png"}
            writer={"Ido Sarusi"}
            minRead={8}
            href={"/blog/best-amazon-sourcing-software"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Manual vs Automated Amazon Product Sourcing in 2026"}
            img={"/blogs/manual-vs-automated-amazon-product-sourcing/image.png"}
            writer={"Ido Sarusi"}
            minRead={9}
            href={"/blog/manual-vs-automated-amazon-product-sourcing"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Online Arbitrage Sourcing Tool: How to Pick One That Actually Finds Profitable Deals"}
            img={"/blogs/online-arbitrage-sourcing-tool/image.png"}
            writer={"Ido Sarusi"}
            minRead={8}
            href={"/blog/online-arbitrage-sourcing-tool"}
          />
        </div>
        <div
          class="column is-3"
          style={{ padding: props.isMobile ? "10%" : "2.5%" }}
        >
          <BlogCardPreview
            title={"Automated Amazon Sourcing in 2026: How to Replace Manual Hunting Without Losing Margin"}
            img={"/blogs/automated-amazon-sourcing/image.png"}
            writer={"Ido Sarusi"}
            minRead={9}
            href={"/blog/automated-amazon-sourcing"}
          />
        </div>
      </div>
    </>
  );
}

export default Blogs;
